import * as React from "react";

import * as S from "@styled";
import { Utilities } from "shared/utilities";
import { MultiCreatable } from "shared/components/select/Select";
import { Option } from "shared/model/Option";

interface TagsInputProps {
    label: string;
    availableTags: string[];
    selectedTags?: string[];
    handleChangeTags: (newValues: Option<string>[]) => void;
    disabled?: boolean;
}

const TagsInput: React.FC<TagsInputProps> = (props) => (
    <S.FormGroup>
        <S.Label>
            {props.label}
        </S.Label>
        <MultiCreatable
            id={`${props.label}-input`}
            name={props.label}
            value={Utilities.optionsFromValues(props.selectedTags)}
            options={Utilities.optionsFromValues(props.availableTags)}
            noOptionsMessage={() => "No available tags found, create new ones by typing"}
            placeholder={FRENDS.Localizations.Select}
            onChange={props.handleChangeTags}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            isDisabled={props.disabled}
        />
    </S.FormGroup>
)

export default TagsInput;